import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  InputLabel,
  Grid,
  Box,
  Menu,
  InputAdornment,
  MenuItem,
  TablePagination,
  IconButton,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddProduct from "./AddProduct";
import MaterialTable from "material-table";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { debounce } from "lodash";
import { btnCss, TextfieldCss, ClsBtn } from "../../../Styles";
import CancelIcon from "@mui/icons-material/Cancel";
import { notify, formatDate, formatDateOnly, isMobile } from "../../Common";
import { apiFetch } from "../../../API/CommonApi";
import { loadProducts as apiLoadProducts } from "../../../API/ProductLayer";
import { delProduct as apiDelProduct } from "../../../API/ProductLayer";
import { useAuth } from "../../../Context/Auth";
import MetaCatalogModal from "../../Catalog/MetaCatalogModal";
import { checkwhatsAppBusinessAcc as WPCheck } from "../../../API/AuthLayer";
function Products() {
  //states
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(null);
  const [searchKey, setSearch] = useState(null);
  const [products, setProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const deleteDrop = Boolean(anchorEl);
  const [deleteData, setDeleteData] = useState(null);
  const mobileScreen = isMobile();
  const [metaModalOpen, setMetaModalOpen] = useState(false);
  // Ensure you are fetching the whatsappAccount details in your useEffect
  // const [whatsappAccount, setWhatsappAccount] = useState(null);
  const auth = useAuth();
  const whatsappAccount = auth?.wpDetails[0];
  // const companyId = whatsappAccount?.company;
  useEffect(() => {
    WPCheck().then((res) => {
      if (res?.length) {
        const updatedAccount = res[0];
        console.log("Updated whatsappAccount", updatedAccount);
      }
    });
    // console.log("companyId in products", companyId);
  }, []);

  // to Open modal
  const handleAddorEdit = (data) => {
    setOpen(true);
    data && setEditData(data);
    console.log();
  };

  // to close Modal
  const handleClose = () => {
    setOpen(false);
    setEditData(null);
  };

  //Loading products

  const loadProducts = (param) => {
    apiLoadProducts(param)
      .then((res) => {
        console.log(res);
        setProducts(res.results);
        console.log(products.results);
        setCount(res.count);
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };

  const delProduct = (rowData) => {
    apiDelProduct(rowData.id).then(() => {
      setAnchorEl(null);
      setDeleteData(null);
      loadProducts(null);
      notify("warn", "Product Deleted");
    });
  };

  useEffect(() => {
    if (page && searchKey) {
      loadProducts(`page=${page}&search=${searchKey}`);
    }
    if (page) {
      loadProducts(`page=${page}`);
    }
  }, [page]);

  //columns
  const columns = [
    {
      title: "Product name",
      field: "name",
      render: (rowData) => (
        <div className="column-1">
          {/* <img src={profileUrl} className="profilePic" /> */}
          <span>
            <p style={{ textTransform: "capitalize" }}>
              {rowData.name.replace(/_/g, " ")}
            </p>
            <p> </p>
          </span>
        </div>
      ),
    },
    {
      title: "Product Image",
      field: "image",
      render: (rowData) => (
        <div className="column-2">
          {rowData.image && (
            <img
              src={rowData.image}
              alt="Product Image"
              className="productImage"
              style={{ width: "120px", height: "100px" }}
            />
          )}
        </div>
      ),
    },
    {
      title: "Price",
      field: "price",
      render: (rowData) => (
        <p>{rowData.price} {rowData.currency}</p>
      ),
    },
    {
      title: "SKU",
      field: "sku",
      render: (rowData) => (
        <p style={{ color: "#666" }}>{rowData.sku || "-"}</p>
      ),
    },
    {
      title: "Description",
      field: "description",
      hidden: mobileScreen, // Hide on mobile to save space
      render: (rowData) => (
        <p style={{ 
          maxWidth: "200px", 
          overflow: "hidden", 
          textOverflow: "ellipsis", 
          whiteSpace: "nowrap" 
        }}>
          {rowData.description || "-"}
        </p>
      ),
    },
    {
      title: "Created Date",
      field: "createdDate",
      render: (rowData) => (
        <p className="column-4">{formatDate(rowData?.created_at)}</p>
      ),
    },
    {
      title: "Updated at",
      field: "updated_at",
      render: (rowData) => (
        <p className="column-4">{formatDate(rowData?.updated_at)}</p>
      ),
    },
    {
      title: "Edit/ Delete",
      field: "editelete",
      render: (rowData) => (
        <div className="column-5">
          <p>
            <EditIcon
              className="Icon"
              onClick={() => {
                handleAddorEdit(rowData);
              }}
            />
          </p>
          <p>
            <DeleteOutlineOutlinedIcon
              className="Icon"
              onClick={(event) => {
                setDeleteData(rowData);
                setAnchorEl(event.currentTarget);
              }}
            />
          </p>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={deleteDrop}
            onClose={() => {
              setAnchorEl(null);
              setDeleteData(null);
            }}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <div
              style={{
                padding: "5px",
              }}
            >
              <p style={{ paddingBottom: "5px" }}>Confirmation:</p>
              <Button
                variant="contained"
                sx={{
                  margin: "5px",
                }}
                size="small"
                onClick={() => {
                  delProduct(deleteData);
                }}
              >
                Delete
              </Button>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  margin: "5px",
                }}
                onClick={() => {
                  setAnchorEl(null);
                  setDeleteData(null);
                }}
              >
                Cancel
              </Button>
            </div>
          </Menu>
        </div>
      ),
    },
  ];
  const debouncedSearch = debounce((searchKey) => {
    if (searchKey) {
      loadProducts(`search=${searchKey}`);
    }
  }, 600);
  useEffect(() => {
    loadProducts(null);
  }, []);

  return (
    <div>
      <div className="pageInNav">
        <p className="pageH">Products</p>
        <div className="inNavCtr"></div>
      </div>
      <Paper elevation={2} className="table">
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "15px 10px",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <div
              style={{
                width: mobileScreen ? "100%" : "315px",
              }}
            >
              <TextField
                style={TextfieldCss}
                size="small"
                variant="outlined"
                placeholder="Search "
                type="search"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  debouncedSearch(e.target.value);
                  setSearch(e.target.value);
                  if (!e.target.value) {
                    loadProducts();
                  }
                }}
              />
            </div>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                handleAddorEdit(null);
              }}
              sx={btnCss}
            >
              ADD PRODUCT
            </Button>
            <Button 
                variant="contained" 
                sx={{ ...btnCss, ml: 2, backgroundColor: "#075E54" }} 
                onClick={() => setMetaModalOpen(true)}
            >
                Meta Catalog
            </Button>
          </div>

          <MaterialTable
            sx={{
              border: "1px solid red",
              borderRadius: "10px",
            }}
            columns={columns}
            data={products ? products : []}
            components={{
              Toolbar: () => <></>,
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  rowsPerPage={10}
                  rowsPerPageOptions={[10]}
                  count={count ? count : 0}
                  page={page - 1}
                  onPageChange={(e, page) => setPage(page + 1)}
                  labelDisplayedRows={() => null}
                />
              ),
            }}
            options={{
              search: false,
              toolbar: false,
              showTitle: false,
              paging: true,
              pageSize: 10,

              headerStyle: {
                border: "1px solid #EDDCDC",
                maxHeight: "50px0",
                zIndex: 2,
                backgroundColor: "#FBFBFB",
              },
            }}
          />
        </div>
      </Paper>
      <AddProduct
        open={open}
        handleClose={handleClose}
        loadProducts={loadProducts}
        editData={editData}
      />
      <MetaCatalogModal 
        open={metaModalOpen} 
        handleClose={() => setMetaModalOpen(false)}
        whatsappAccount={whatsappAccount} 
      />
      {/* <MetaCatalogSetup whatsappAccount={whatsappAccount} companyId={companyId} /> */}
    </div>
  );
}

export default Products;
